import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
  computed,
  input,
} from '@angular/core';
import { SortState } from '@shared/components/simple-table/models/sort-state.model';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Cabeçalho de coluna ordenável reutilizável. Renderiza um <button> (a11y/teclado)
 * com seta sólida ▲/▼ na coluna ativa e seta neutra discreta (⇅) nas ordenáveis
 * inativas. Emite o `field` ao clicar; o ciclo de estados fica a cargo do pai.
 */
@Component({
    selector: 'app-sortable-header',
    templateUrl: './sortable-header.component.html',
    styleUrls: ['./sortable-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, TranslatePipe],
})
export class SortableHeaderComponent {
  readonly field = input.required<string>();
  readonly label = input<string>('');
  readonly sortable = input<boolean>(false);
  readonly state = input<SortState>({ sortKey: null, sortDir: null });

  @Output() sort = new EventEmitter<string>();

  readonly isActive = computed(
    () => this.sortable() && this.state().sortKey === this.field(),
  );

  readonly isAsc = computed(() => this.isActive() && this.state().sortDir === 'asc');
  readonly isDesc = computed(() => this.isActive() && this.state().sortDir === 'desc');

  /** Valor de aria-sort para o <th>. */
  readonly ariaSort = computed<'ascending' | 'descending' | 'none'>(() => {
    if (!this.isActive()) return 'none';
    return this.state().sortDir === 'asc' ? 'ascending' : 'descending';
  });

  onClick(): void {
    if (!this.sortable()) return;
    this.sort.emit(this.field());
  }
}
